import React from 'react';
import { achievements } from '../data/profile';

const Achievements = () => {
  return (
    <section id="recognition" className="section">
      <div className="container">
        <header className="section-head">
          <p className="eyebrow">Recognition</p>
          <h2>Competitions and contributions.</h2>
        </header>
        <div className="achievement-grid">
          {achievements.map((item) => (
            <article className="achievement-card" key={item.detail}>
              <h3>{item.title}</h3>
              <p>
                <strong>{item.detail}</strong>
              </p>
              <p>{item.event}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Achievements;
